import React from "react";
import { Icon } from "@/components/Icon";
import { cn } from "@/lib/utils";

/* EmptyState — the shared "request succeeded but there's nothing" panel
   (PREMIUM_UI_DIRECTION §4.10). Distinct from LoadError (request FAILED → retry).
   Dashed neutral panel, muted icon, one-line message, optional neutral CTA.

   Props:
   - icon (default "search"): Icon name
   - message: the one-line explanation (required-ish)
   - action: optional { label, onClick } neutral CTA
   - testid (default "empty-state")
   - className */
export default function EmptyState({
  icon = "search",
  message = "Nothing here yet.",
  action = null,
  testid = "empty-state",
  className,
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center gap-3 rounded-2xl border border-dashed border-surface-border bg-surface-3 py-14 text-center",
        className
      )}
      data-testid={testid}
    >
      <Icon name={icon} size={26} className="text-[#52525b]" />
      <p className="text-sm text-meta">{message}</p>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          data-testid={`${testid}-action`}
          className="inline-flex items-center gap-2 rounded-full border border-surface-border bg-surface-4 px-4 py-2 text-sm font-bold text-white transition-colors hover:border-border-strong focus-ring"
        >
          {action.icon && <Icon name={action.icon} size={15} />}
          {action.label}
        </button>
      )}
    </div>
  );
}
